import values from 'lodash/values';
import concat from 'lodash/concat';
import ListingType, { ResidentialListingTypeKeys, CommercialListingTypeKeys } from './listing-type';
export var PropertyFeatureKeys = ['A_GRADE_BUILDING', 'AIR_CONDITIONING', 'ALARM', 'BODY_CORPORATE', 'CARPORT_SPACES', 'CENTRAL_HEAT', 'COLD_SHELL', 'CORE_AREA', 'DEDICATED_PARKING', 'DINING_ROOM', 'DISABILITY_FRIENDLY', 'DISABLED_ACCESS', 'DUAL_ACCESS', 'ENSUITES', 'EXHAUST_FIT_OUT', 'EXHAUST_POINT', 'FAMILY_ROOM', 'GARAGE', 'GREASE_TRAP', 'HARD_STAND_AREA', 'HEAVY_VEHICLE_ACCESS', 'HIGH_CLEARANCE', 'LOADING_DOCK', 'NATURAL_LIGHT', 'NEW_CONSTRUCTION', 'NON_STRATA', 'OFF_STREET_PARKING', 'OUTDOOR_AREA', 'OVER_FIFTY_FIVE', 'OVER_SIXTY', 'PETS_ALLOWED', 'RUMPUS_ROOM', 'SELF_CONTAINED_FLAT', 'STRATA', 'STREET_FRONTAGE', 'STUDY', 'SUNROOM', 'SWIMMING_POOL', 'UNDERGROUND_PARKING', 'UV_BARGAIN', 'WARM_SHELL', 'FULLY_FURNISHED'];
var PropertyFeatureValues = {
  A_GRADE_BUILDING: {
    name: 'A_GRADE_BUILDING',
    label: 'A-grade Building',
    urlSlug: 'a-grade-building',
    listingTypes: CommercialListingTypeKeys,
    inUse: false
  },
  AIR_CONDITIONING: {
    name: 'AIR_CONDITIONING',
    label: 'Air Conditioning',
    urlSlug: 'air-conditioning',
    listingTypes: concat(ResidentialListingTypeKeys, CommercialListingTypeKeys),
    inUse: true
  },
  ALARM: {
    name: 'ALARM',
    label: 'Alarm',
    urlSlug: 'alarm',
    listingTypes: concat(ResidentialListingTypeKeys, CommercialListingTypeKeys),
    inUse: true
  },
  BODY_CORPORATE: {
    name: 'BODY_CORPORATE',
    label: 'Body Corporate',
    urlSlug: 'body-corporate',
    listingTypes: ResidentialListingTypeKeys,
    inUse: false
  },
  CARPORT_SPACES: {
    name: 'CARPORT_SPACES',
    label: 'Carport Spaces',
    urlSlug: 'carport',
    listingTypes: ResidentialListingTypeKeys,
    inUse: false
  },
  CENTRAL_HEAT: {
    name: 'CENTRAL_HEAT',
    label: 'Central Heating',
    urlSlug: 'central-heating',
    listingTypes: ResidentialListingTypeKeys,
    inUse: true
  },
  COLD_SHELL: {
    name: 'COLD_SHELL',
    label: 'Cold Shell',
    urlSlug: 'cold-shell',
    listingTypes: CommercialListingTypeKeys,
    inUse: false
  },
  CORE_AREA: {
    name: 'CORE_AREA',
    label: 'Core Area',
    urlSlug: 'core-area',
    listingTypes: ResidentialListingTypeKeys,
    inUse: false
  },
  DEDICATED_PARKING: {
    name: 'DEDICATED_PARKING',
    label: 'Dedicated Parking',
    urlSlug: 'dedicated-parking',
    listingTypes: CommercialListingTypeKeys,
    inUse: true
  },
  DINING_ROOM: {
    name: 'DINING_ROOM',
    label: 'Dining Room',
    urlSlug: 'dining-room',
    listingTypes: ResidentialListingTypeKeys,
    inUse: false
  },
  DISABILITY_FRIENDLY: {
    name: 'DISABILITY_FRIENDLY',
    label: 'Disability Friendly',
    urlSlug: 'disabilty-friendly',
    listingTypes: ResidentialListingTypeKeys,
    inUse: true
  },
  DISABLED_ACCESS: {
    name: 'DISABLED_ACCESS',
    label: 'Disabled Access',
    urlSlug: 'disabled-access',
    listingTypes: CommercialListingTypeKeys,
    inUse: false
  },
  DUAL_ACCESS: {
    name: 'DUAL_ACCESS',
    label: 'Dual Access',
    urlSlug: 'dual-access',
    listingTypes: CommercialListingTypeKeys,
    inUse: false
  },
  ENSUITES: {
    name: 'ENSUITES',
    label: 'Ensuites',
    urlSlug: 'ensuites',
    listingTypes: ResidentialListingTypeKeys,
    inUse: true
  },
  EXHAUST_FIT_OUT: {
    name: 'EXHAUST_FIT_OUT',
    label: 'Exhaust Fit Out',
    urlSlug: 'exhaust-fit-out',
    listingTypes: CommercialListingTypeKeys,
    inUse: true
  },
  EXHAUST_POINT: {
    name: 'EXHAUST_POINT',
    label: 'Exhaust Point',
    urlSlug: 'exhaust-point',
    listingTypes: CommercialListingTypeKeys,
    inUse: true
  },
  FAMILY_ROOM: {
    name: 'FAMILY_ROOM',
    label: 'Family Room',
    urlSlug: 'family-room',
    listingTypes: ResidentialListingTypeKeys,
    inUse: false
  },
  GARAGE: {
    name: 'GARAGE',
    label: 'Garage',
    urlSlug: 'garage',
    listingTypes: ResidentialListingTypeKeys,
    inUse: false
  },
  GREASE_TRAP: {
    name: 'GREASE_TRAP',
    label: 'Grease Trap',
    urlSlug: 'grease-trap',
    listingTypes: CommercialListingTypeKeys,
    inUse: false
  },
  HARD_STAND_AREA: {
    name: 'HARD_STAND_AREA',
    label: 'High Stand Area',
    urlSlug: 'high-stand-area',
    listingTypes: CommercialListingTypeKeys,
    inUse: false
  },
  HEAVY_VEHICLE_ACCESS: {
    name: 'HEAVY_VEHICLE_ACCESS',
    label: 'Heavy Vehicle Access',
    urlSlug: 'heavy-vehicle-access',
    listingTypes: CommercialListingTypeKeys,
    inUse: true
  },
  HIGH_CLEARANCE: {
    name: 'HIGH_CLEARANCE',
    label: 'High Clearance',
    urlSlug: 'high-clearance',
    listingTypes: CommercialListingTypeKeys,
    inUse: false
  },
  LOADING_DOCK: {
    name: 'LOADING_DOCK',
    label: 'Loading Dock',
    urlSlug: 'loading-dock',
    listingTypes: CommercialListingTypeKeys,
    inUse: true
  },
  NATURAL_LIGHT: {
    name: 'NATURAL_LIGHT',
    label: 'Natural Light',
    urlSlug: 'natural-light',
    listingTypes: CommercialListingTypeKeys,
    inUse: false
  },
  NEW_CONSTRUCTION: {
    name: 'NEW_CONSTRUCTION',
    label: 'New Construction',
    urlSlug: 'new-construction',
    listingTypes: ResidentialListingTypeKeys,
    inUse: false
  },
  NON_STRATA: {
    name: 'NON_STRATA',
    label: 'Non-strata',
    urlSlug: 'non-strata',
    listingTypes: CommercialListingTypeKeys,
    inUse: false
  },
  OFF_STREET_PARKING: {
    name: 'OFF_STREET_PARKING',
    label: 'Off-street Parking',
    urlSlug: 'off-street-parking',
    listingTypes: ResidentialListingTypeKeys,
    inUse: false
  },
  OUTDOOR_AREA: {
    name: 'OUTDOOR_AREA',
    label: 'Outdoor Area',
    urlSlug: 'outdoor-area',
    listingTypes: CommercialListingTypeKeys,
    inUse: true
  },
  OVER_FIFTY_FIVE: {
    name: 'OVER_FIFTY_FIVE',
    label: 'Over 55s',
    urlSlug: 'over-55s',
    listingTypes: [ListingType.SALES_RESIDENTIAL.name, ListingType.RENTAL_RESIDENTIAL.name, ListingType.DEVELOPMENTS_RESIDENTIAL.name],
    inUse: true
  },
  OVER_SIXTY: {
    name: 'OVER_SIXTY',
    label: 'Over 60s',
    urlSlug: 'over-60s',
    listingTypes: [ListingType.SALES_RESIDENTIAL.name, ListingType.DEVELOPMENTS_RESIDENTIAL.name],
    inUse: false
  },
  PETS_ALLOWED: {
    name: 'PETS_ALLOWED',
    label: 'Pet Friendly',
    urlSlug: 'pets',
    listingTypes: [ListingType.RENTAL_RESIDENTIAL.name],
    inUse: true
  },
  RUMPUS_ROOM: {
    name: 'RUMPUS_ROOM',
    label: 'Rumpus Room',
    urlSlug: 'rumpus-room',
    listingTypes: ResidentialListingTypeKeys,
    inUse: false
  },
  SELF_CONTAINED_FLAT: {
    name: 'SELF_CONTAINED_FLAT',
    label: 'Self-contained Flat',
    urlSlug: 'flat',
    listingTypes: ResidentialListingTypeKeys,
    inUse: true
  },
  STRATA: {
    name: 'STRATA',
    label: 'Strata',
    urlSlug: 'strata',
    listingTypes: CommercialListingTypeKeys,
    inUse: true
  },
  STREET_FRONTAGE: {
    name: 'STREET_FRONTAGE',
    label: 'Street Frontage',
    urlSlug: 'street-frontage',
    listingTypes: CommercialListingTypeKeys,
    inUse: false
  },
  STUDY: {
    name: 'STUDY',
    label: 'Study',
    urlSlug: 'study',
    listingTypes: ResidentialListingTypeKeys,
    inUse: false
  },
  SUNROOM: {
    name: 'SUNROOM',
    label: 'Sunroom',
    urlSlug: 'sunroom',
    listingTypes: ResidentialListingTypeKeys,
    inUse: false
  },
  SWIMMING_POOL: {
    name: 'SWIMMING_POOL',
    label: 'Swimming Pool',
    urlSlug: 'pool',
    listingTypes: ResidentialListingTypeKeys,
    inUse: true
  },
  UNDERGROUND_PARKING: {
    name: 'UNDERGROUND_PARKING',
    label: 'Underground Parking',
    urlSlug: 'underground-parking',
    listingTypes: CommercialListingTypeKeys,
    inUse: true
  },
  UV_BARGAIN: {
    name: 'UV_BARGAIN',
    label: 'UV Bargain',
    urlSlug: 'uv-bargain',
    listingTypes: ResidentialListingTypeKeys,
    inUse: false
  },
  WARM_SHELL: {
    name: 'WARM_SHELL',
    label: 'Warm Shell',
    urlSlug: 'warm-shell',
    listingTypes: CommercialListingTypeKeys,
    inUse: false
  },
  FULLY_FURNISHED: {
    name: 'FULLY_FURNISHED',
    label: 'Fully Furnished',
    urlSlug: 'fully-furnished',
    listingTypes: [ListingType.RENTAL_RESIDENTIAL.name],
    inUse: true
  }
};
var PropertyFeature = PropertyFeatureValues;
export var getPropertyFeatureForType = listingType => values(PropertyFeature).filter(each => each.listingTypes.includes(listingType) && each.inUse);
export default PropertyFeature;